import { useSelector } from "react-redux";

import FilterData from "../Filter/FilterData";
import SearchTable from "./SearchTable";
import MultipleCheck from "./MultipleCheck";
import ButtonIcon from "../UI/buttonUI/ButtonIcon";
import { CirclePlus } from "lucide-react";
import ExportButton from "../exportExcel/ExportButton";

const FilterSearch = ({
  categories,
  searchCategories,
  isActionSucceed,
  checkResponseDataId,
  expenseCheck,
  isMultipleCheck,
  setMultipleCheck,
  setSelectedChecks,
  enableMultiCheckApplyBtn,
  cancelMultipleCheck,
  handleMultiCheckConfirmDialog,
  checkedData,
  checkedRow,
  addBtnText,
  addBtnNavigation,
  excelConfig,
}) => {
  const copyData = useSelector((state) => state.data.copyData);
  const isCopyData = copyData.length > 0;
  const showFilter = categories && isCopyData;
  const showSearch = searchCategories && isCopyData;
  return (
    <div className="filter-search">
      {expenseCheck ? (
        <div className="flex items-center">
          {checkedRow.length !== 0 && (
            <p className="mr-2 font-figtree">{`(${checkedRow.length})`}</p>
          )}
          <MultipleCheck
            isMultipleCheck={isMultipleCheck}
            setMultipleCheck={setMultipleCheck}
            setSelectedChecks={setSelectedChecks}
            enableMultiCheckApplyBtn={enableMultiCheckApplyBtn}
            cancelMultipleCheck={cancelMultipleCheck}
            handleMultiCheckConfirmDialog={handleMultiCheckConfirmDialog}
            checkedData={checkedData}
          />
        </div>
      ) : (
        ""
      )}
      <div
        className={`flex ${
          !expenseCheck ? "justify-between w-full" : "gap-1"
        } filterSearchWrap`}
      >
        {showFilter && (
          <FilterData
            categories={categories}
            isActionSucceed={isActionSucceed}
            checkResponseDataId={checkResponseDataId}
          />
        )}
        <div
          className={`${
            addBtnText === "Add User" ||
            addBtnText === "Upload Sheet" ||
            addBtnText === "Add Officer"
              ? "justify-between w-full"
              : ""
          } flex justify-end w-full`}
        >
          {showSearch && <SearchTable searchCategories={searchCategories} />}
          <div className="pl-1 2xs:max-md:hidden">
            {addBtnText && (
              <ButtonIcon
                btnText={addBtnText}
                Icon={CirclePlus}
                nav={addBtnNavigation}
                size={15}
              />
            )}
          </div>
          {excelConfig && <ExportButton excelConfig={excelConfig} />}
        </div>
      </div>
    </div>
  );
};
export default FilterSearch;
